import CrossSVG from '@public/icons/cross.svg';
import classNames from 'classnames';
import { LinkProps } from 'next/link';
import { AnchorHTMLAttributes, ButtonHTMLAttributes, HTMLAttributes } from 'react';
import Link from '@/shared/components/shared/Link';

type Props = ButtonHTMLAttributes<HTMLButtonElement> &
    AnchorHTMLAttributes<HTMLAnchorElement> &
    Partial<LinkProps> & {
        text?: string;
        tag?: keyof JSX.IntrinsicElements | typeof Link;
        variant?: 'default' | 'white';
    };

const CloseButton = ({ text, variant = 'default', tag = 'button', ...props }: Props) => {
    const Component = tag as any;
    return (
        <Component {...props} className={classNames('close-button', `close-button-${variant}`, props.className)}>
            <span className="close-button__icon">
                <CrossSVG />
            </span>
            {text && <span className="close-button__text text-s">{text}</span>}
        </Component>
    );
};

export default CloseButton;
